import FooterLogo from "shared/Logo/FooterLogo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";
import Input from "shared/Input/Input";
import ButtonCircle from "shared/Button/ButtonCircle";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Europe Tours & Travels",
    menus: [
      { href: "/", label: "Home" },
      { href: "/tour-package", label: "Tours Packages" },
      { href: "/ourfleets", label: "Fleets" },
      { href: "/fixed-departure", label: "Fixed Departure" },
    ],
  },
  {
    id: "1",
    title: "Contact",
    menus: [
      { href: "/contact", label: "Europe Tours & Travels," },
      {
        href: "https://maps.google.com/?q=Zurich,Switzerland",
        label: "Zurich, Switzerland",
      },
      { href: "tel:+41798847550", label: "+41798847550" },
      { href: "mailto:info@ettravels.com", label: "info@ettravels.com" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="flex flex-col">
        <h3 className="text-base font-semibold text-white mb-6 tracking-wide">
          {menu.title}
        </h3>
        <ul className="space-y-3 flex flex-col">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                className="text-gray-300 hover:text-white transition-colors duration-200 text-sm leading-relaxed"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <footer className="relative" style={{ backgroundColor: "#001253" }}>
      <div className="container px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Main content grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-16">
          {/* Logo & Social Links */}
          <div className="flex flex-col">
            <div className="mb-8">
              <FooterLogo />
            </div>
            <div className="flex flex-col">
              <p className="text-xs uppercase text-gray-400 font-semibold tracking-widest mb-4">
                Follow Us
              </p>
              <SocialsList1 className="flex gap-4" />
            </div>
          </div>

          {/* Navigation Menus */}
          {widgetMenus.map(renderWidgetMenuItem)}

          {/* Newsletter Signup */}
          <div className="flex flex-col">
            <h3 className="text-base font-semibold text-white mb-6 tracking-wide">
              Newsletter
            </h3>
            <p className="text-gray-300 text-sm mb-4 leading-relaxed">
              Subscribe to get exclusive travel offers and updates.
            </p>
            <form className="relative mt-auto">
              <Input
                required
                aria-required
                placeholder="Enter your email"
                type="email"
                rounded="rounded-full"
                className="w-full bg-white bg-opacity-10 text-white placeholder-gray-400 border border-gray-500 focus:border-white transition-colors"
              />
              <ButtonCircle
                type="submit"
                className="absolute transform top-1/2 -translate-y-1/2 right-2 bg-white hover:bg-gray-100 transition-colors"
              >
                <i className="las la-arrow-right text-lg text-gray-900"></i>
              </ButtonCircle>
            </form>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mb-6"></div>

        {/* Copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400 text-center sm:text-left">
            © {new Date().getFullYear()}{" "}
            <a href="/" className="text-white hover:text-gray-200 transition-colors">
              Europe Tours & Travels
            </a>
            . All rights reserved.
          </p>
          <div className="flex gap-6 text-xs">
            <a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" className="text-gray-400 hover:text-white transition-colors">
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
